import React from 'react'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { TwitterTimeline } from './TwitterTimeline'

export interface TwitterTimelineRouteProps {
    user: string
    height: string
}

export const TwitterTimelineRegistration = createRegisterableComponent(
    'twitter-timeline',
    (props: TwitterTimelineRouteProps, services) => (
        <TwitterTimeline key={`twitter-timeline${services.location.pathname}`} {...props} /> // key required to use location to force remount
    )
)
